import { getI18nInstance } from '@/i18n';
import { ROLES } from '@/models/User';
import MagazinIndex from '@/views/auth/magazin/index.vue';
import MagazinEdit from '@/views/auth/magazin/_id.vue';
import Basisdaten from '@/views/auth/magazin/_id/basisdaten.vue';
import Titelbild from '@/views/auth/magazin/_id/titelbild.vue';
import Contents from '@/views/auth/magazin/_id/contents.vue';
import Events from '@/views/auth/magazin/_id/events.vue';
import Addresses from '@/views/auth/magazin/_id/addresses.vue';
import Metadata from '@/views/auth/magazin/_id/metadata.vue';

export default [
    {
        path: '/magazin',
        name: 'magazin',
        component: MagazinIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.WRITER],
            title: () => getI18nInstance().t('magazin'),
        },
    },
    {
        path: '/magazin/:id',
        component: MagazinEdit,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN, ROLES.EDITOR, ROLES.WRITER],
            title: () => getI18nInstance().t('magazin'),
        },
        children: [
            {
                path: '/',
                name: 'magazin-edit',
                component: Basisdaten,
            },
            {
                path: 'images',
                name: 'magazin-edit-image',
                component: Titelbild,
            },
            {
                path: 'content',
                name: 'magazin-edit-content',
                component: Contents,
            },
            {
                path: 'events',
                name: 'magazin-edit-events',
                component: Events,
            },
            {
                path: 'addresses',
                name: 'magazin-edit-addresses',
                component: Addresses,
            },
            {
                path: 'metadata',
                name: 'magazin-metadata',
                component: Metadata,
            },
        ],
    },
];
